import store from '../store'

export default () => {
    return {
        Authorization:`Bearer ${store.state.accessToken}`
    }

}